module.exports = __webpack_public_path__ + "img/default-logo.a7bbd01c.png";